import { config } from './index'

export const getEnvironmentBadgeLabel = (
  environment: string
): 'Development mode' | 'Demo mode' | null => {
  if (environment === 'dev') return 'Development mode'
  if (environment === 'demo') return 'Demo mode'
  return null
}

export const environmentBadgeLabel = getEnvironmentBadgeLabel(config.ENVIRONMENT)
